let questionstab = document.querySelectorAll(".questionstab");

questionstab.forEach(questionstab => {
  questionstab.addEventListener("click", event => {

    const active = document.querySelector(".questionstab.active");

    if (active && active !== questionstab) {
      active.classList.toggle("active");
      active.nextElementSibling.style.maxHeight = 0;
    }

    questionstab.classList.toggle("active");

    const answerstab = questionstab.nextElementSibling;

    if (questionstab.classList.contains("active")) {
      answerstab.style.maxHeight = (answerstab.scrollHeight + 20) + "px";
    } else {
      answerstab.style.maxHeight = 0;
    }

  });
});